import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { ensureFeatureModules } from '@/api/featureModulesApi';
import {
  DEFAULT_FEATURE_MODULES,
  type FeatureModuleKey,
  type FeatureModules,
  isFeatureEnabled,
} from '@/utils/featureModules';

export const useFeatureModulesStore = defineStore('featureModules', () => {
  const modules = ref<FeatureModules>({ ...DEFAULT_FEATURE_MODULES });
  const loaded = ref(false);

  const knowledgeEnabled = computed(() => modules.value.knowledgeEnabled);
  const aiToolsEnabled = computed(() => modules.value.aiToolsEnabled);
  const projectManagementEnabled = computed(() => modules.value.projectManagementEnabled);
  const smartDocumentEnabled = computed(() => modules.value.smartDocumentEnabled);

  async function fetchFeatures(force = false): Promise<FeatureModules> {
    const next = await ensureFeatureModules(force);
    modules.value = { ...next };
    loaded.value = true;
    return modules.value;
  }

  function enabled(key: FeatureModuleKey): boolean {
    return isFeatureEnabled(key, modules.value);
  }

  /** 关闭某功能时的回退路由名 */
  function fallbackRouteName(): string {
    if (modules.value.knowledgeEnabled) return 'KnowledgeSpace';
    if (modules.value.aiToolsEnabled) return 'AiTools';
    return 'Dashboard';
  }

  return {
    modules,
    loaded,
    knowledgeEnabled,
    aiToolsEnabled,
    projectManagementEnabled,
    smartDocumentEnabled,
    fetchFeatures,
    enabled,
    fallbackRouteName,
  };
});
